module.exports = __webpack_public_path__ + "static/media/YF55_3.c2e85351.jpg";